
export const network = {
  partnerNetwork: {
    title: "เครือข่ายพันธมิตร",
    connect: "เชื่อมต่อพันธมิตร",
    myCode: "รหัสคลินิกของคุณ",
    copy: "คัดลอกรหัส",
    status: "สถานะการเชื่อมต่อ",
    pending: "รอการอนุมัติ",
    active: "เชื่อมต่อแล้ว",
    rejected: "ปฏิเสธ",
    providerMode: "โหมดผู้ให้บริการ (Clinic)",
    clientMode: "โหมดผู้รับบริการ (Dispensary)",
    connectTitle: "เชื่อมต่อกับคลินิก",
    connectDesc: "กรอกรหัสคลินิกที่คุณได้รับ เพื่อส่งผู้ป่วยไปรับการรักษา",
    partnerCode: "รหัสพันธมิตร (Partner Code)",
    connectBtn: "เชื่อมต่อ",
    subtitle: "เชื่อมต่อระบบของคุณกับ คลินิก หรือ ร้านขายยา ภายนอก เพื่อรับ-ส่งต่อผู้ป่วย",
    incomingReq: "คำขอที่เข้ามา (Incoming)",
    outgoingReq: "คำขอที่ส่งไป (Outgoing)",
    accept: "ยอมรับ",
    reject: "ปฏิเสธ",
    empty: "ยังไม่มีการเชื่อมต่อ",
    emptyClient: "ยังไม่ได้เชื่อมต่อคลินิก",
    noteTitle: "หมายเหตุ",
    noteDesc: "เมื่อเชื่อมต่อสำเร็จ คุณจะสามารถเลือกส่งตัวผู้ป่วยไปยังคลินิกพันธมิตรได้ในหน้าลงทะเบียน",
    cannotSelf: "ไม่สามารถเชื่อมต่อกับรหัสร้านตัวเองได้"
  },
  loyaltyManagement: {
    title: "ระบบสมาชิก",
    loading: "กำลังโหลด...",
    addNewReward: "เพิ่มของรางวัล",
    addNewTier: "เพิ่มระดับสมาชิก",
    deleteConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบ {{item}}?",
    tabs: {
      rewards: "ของรางวัล",
      tiers: "ระดับสมาชิก"
    },
    rewardsTable: {
      name: "ชื่อรางวัล",
      sku: "SKU",
      points: "แต้มที่ใช้",
      cost: "ต้นทุน",
      status: "สถานะ"
    },
    tiersTable: {
      icon: "ไอคอน",
      name: "ชื่อระดับ",
      minPoints: "แต้มขั้นต่ำ",
      benefits: "สิทธิประโยชน์"
    }
  }
};
